var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "category-card",
      attrs: { to: { name: "category", params: { id: _vm.data.id } } },
    },
    [
      _c("div", { staticClass: "category-card__text" }, [
        _c("h4", [_vm._v(_vm._s(_vm.data.title))]),
        _c(
          "span",
          { staticClass: "category-card__route" },
          [
            _vm._v("Подробнее\n      "),
            _c("IconComponent", { attrs: { name: "arrow-right" } }),
          ],
          1
        ),
      ]),
      _c("ImgComponent", {
        staticClass: "category-card__img",
        attrs: { head_img: _vm.data.img },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }